const MAIL_URI = process.env.REACT_APP_MAILCHIMP_URI

export { MAIL_URI }
